import React, { useEffect, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { showNotification } from '../../redux/actions/showNotification'

const Index = ({ notificationModal, company, dispatch }) => {
  const [modal, setModal] = useState(false)
  const [simple, setSimple] = useState(true)
  const [content, setContent] = useState({ header: '', body: '', footer: '', btnUrl: '' })

  let timer
  const toggle = () => {
    setModal(!modal)
    showNotification(false, '')(dispatch)
    clearTimeout(timer)
  }

  const contentModal = () => {
    setModal(true)

    let timeout = 2000
    switch (notificationModal.error) {
      case 'errors_unauthorized':
        setContent({ ...content, body: notificationModal.message })
        break
      case 'errors_payment_not_updated':
        timeout = 60000

        setContent({
          ...content,
          body: notificationModal.message,
          header: 'errors_payment_not_updated_header',
          footer: 'dashboard_add-payment-method',
          btnUrl: `/dashboard/management/company/${company._id}/payment/edit`,
        })

        setSimple(false)
        break
      case 'errors_company_billing_data_not_complete':
        timeout = 60000

        setContent({
          ...content,
          body: notificationModal.message,
          header: 'errors_company_billing_data_not_complete_header',
          footer: 'buttons_addBillingData',
          btnUrl: `/dashboard/management/company/${company._id}/edit`,
        })

        setSimple(false)
        break
      case 'errors_operator_session_expirated':
        timeout = 600000
        setContent({
          ...content,
          body: notificationModal.message,
          header: 'errors_operator_session_expirated',
        })

        break
      default:
        break
    }

    timer = (() =>
      setTimeout(() => {
        setModal(false)
        showNotification(false, '')(dispatch)
      }, timeout))()
  }

  useEffect(() => {
    if (notificationModal.show) {
      contentModal()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationModal.show, notificationModal.message])

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>{content.header && I18n.t(content.header)}</ModalHeader>
        <ModalBody>{content.body && I18n.t(content.body)}</ModalBody>
        {!simple && (
          <ModalFooter>
            <Link className='btn btn-primary' to={content.btnUrl} onClick={toggle}>
              {content.footer && I18n.t(content.footer)}
            </Link>
            <Button color='danger' onClick={toggle}>
              {I18n.t('dashboard_cancel')}
            </Button>
          </ModalFooter>
        )}
      </Modal>
    </div>
  )
}

export default connect((state) => ({
  company: state.companies,
  notificationModal: state.showNotification,
}))(Index)
